import React, {useContext, useEffect, useState} from 'react'
import {Button, Form, ListGroup} from 'react-bootstrap'
import {addToExternalCustom} from '../../../../services/external'
import {showMessage} from '../../../../shared/Alerts'
import {SheetEditContext} from '../SheetContexts'

interface Services {
  label: string
  fields: {label: string; identifier: string; type: string}[]
}

const AssigmentListGroup = ({
  onChange,
  elementSelected,
  dataInput,
  serviceSelected,
  setActiveRefetch,
}: any) => {
  const {fieldData, sheetData, sectionData} = useContext(SheetEditContext)
  const [searchQuery, setSearchQuery] = useState('')
  const [inputList, setInputList] = useState<Record<string, Services[]>>({})
  const [checkboxes, setCheckboxes] = useState<Record<string, Record<string, boolean>>>(
    elementSelected
      ? {
          [elementSelected]: {
            read: fieldData.infoAssignTo?.isReadable ?? false,
            write: fieldData.infoAssignTo?.isWritable ?? false,
          },
        }
      : {}
  )

  useEffect(() => {
    setInputList(dataInput)
  }, [dataInput])

  const [selectedItemId, setSelectedItemId] = useState('')

  useEffect(() => {
    if (elementSelected !== '') {
      setSelectedItemId(elementSelected)
    }
  }, [])

  const handleItemClick = (itemId: any) => {
    const item = itemId === selectedItemId ? null : itemId
    setSelectedItemId(item)

    if (itemId !== selectedItemId || !item) {
      const checkboxesMut = {
        ...checkboxes,
        [selectedItemId]: {
          write: false,
          read: false,
        },
      }
      setCheckboxes((prev) => ({
        ...prev,
        [selectedItemId]: {write: false, read: false},
      }))
      onChange(item, checkboxesMut[selectedItemId] ?? {write: false, read: false})
      return
    }
    onChange(item, checkboxes[selectedItemId] ?? {write: false, read: false})
  }

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }

  // Set a maximum height for the ListGroup container
  const maxListHeight = '300px'

  async function handleAddToDb(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    try {
      const seccion = sheetData.sections?.find((x) => x.id === sectionData.id)
      const data = await addToExternalCustom(serviceSelected, {
        tag: fieldData.name,
        tagId: fieldData.id,
        context: seccion?.name,
        contextId: seccion?.id,
        type: fieldData?.type?.[0]?.nombre ?? 'text',
      })

      if (data.success) {
        showMessage('success', 'Campo agregado a entidad colaborador', data.message)
        setActiveRefetch(true)
      } else {
        showMessage(
          'error',
          'Error al agregar a entidad colaborador',
          'Ocurrió un error al agregar el campo a la entidad colaborador.'
        )
      }
    } catch (error) {
      showMessage(
        'error',
        'Error al agregar a entidad colaborador',
        (error as Error).message || 'Ocurrió un error al agregar el campo a la entidad colaborador.'
      )
    }
  }

  const handleCheckboxChange = (checked: boolean, name: string, identifier: string) => {
    const checkboxesMut = {
      ...checkboxes,
      [identifier]: {
        ...(checkboxes[identifier] || {}),
        [name]: checked,
      },
    }
    setCheckboxes((prev) => ({
      ...prev,
      [identifier]: {...(prev[identifier] || {}), [name]: checked},
    }))
    onChange(identifier, checkboxesMut[identifier] ?? {write: false, read: false})
  }

  console.log(inputList?.[serviceSelected]?.every((groups) => (groups?.fields?.length ?? 0) > 0))

  return (
    <>
      <Form.Group>
        <Form.Control
          type='text'
          placeholder='Buscar...'
          value={searchQuery}
          onChange={handleSearchChange}
          className='my-2'
        />
      </Form.Group>
      <div style={{maxHeight: maxListHeight, overflowY: 'scroll'}}>
        {!selectedItemId && (
          <section className='text-center my-3'>
            <p className='text-center text-muted'>No hay datos disponibles</p>
            <Button variant='secondary' size='sm' onClick={handleAddToDb}>
              Vincular campo
            </Button>
          </section>
        )}

        {inputList?.[serviceSelected]?.map((group) => {
          const filteredFields = group.fields.filter((item) =>
            item.label.toLowerCase().includes(searchQuery.toLowerCase())
          )

          if (filteredFields.length === 0) {
            return null
          }

          return (
            <>
              <div className='d-flex justify-content-between align-items-center'>
                <p className='my-3 ms-2 fw-bold'>{group.label}</p>

                <div className='w-120px'>
                  <div className='row m-0 p-0'>
                    <div className='col-6 m-0 p-0 text-center'>Lectura</div>
                    <div className='col-6 m-0 p-0 text-center'>Escritura</div>
                  </div>
                </div>
              </div>
              <ListGroup>
                {filteredFields.map((item: any) => (
                  <ListGroup.Item
                    key={item.identifier}
                    active={item.identifier === selectedItemId}
                    disabled={
                      selectedItemId !== item.identifier &&
                      sheetData.sections?.some((section) =>
                        section.fields?.some((field) => {
                          if (field.id === fieldData.id) {
                            // fieldData.infoAssignTo.assignTo
                            return fieldData?.infoAssignTo?.assignTo === item.identifier
                          }

                          // field.infoAssignTo.assignTo
                          return field?.infoAssignTo?.assignTo === item.identifier
                        })
                      )
                    }
                    onClick={() => {
                      handleItemClick(item.identifier)
                    }}
                  >
                    <div className='d-flex justify-content-between'>
                      <span style={{cursor: 'pointer'}}>{item.label}</span>
                      <div className='w-120px'>
                        <div className='row m-0 p-0'>
                          <div className='col-6 m-0 p-0 text-center'>
                            <input
                              type='checkbox'
                              value='read'
                              name='read'
                              checked={checkboxes?.[item.identifier]?.['read'] ?? false}
                              // disabled={item.identifier !== selectedItemId}
                              onClick={(e) => {
                                e.stopPropagation()
                              }}
                              onChange={(e) => {
                                e.stopPropagation()
                                if (selectedItemId !== item.identifier) {
                                  handleItemClick(item.identifier)
                                }
                                handleCheckboxChange(e.target.checked, 'read', item.identifier)
                              }}
                            />
                          </div>
                          <div className='col-6 m-0 p-0 text-center'>
                            <input
                              type='checkbox'
                              value='write'
                              name='write'
                              checked={checkboxes?.[item.identifier]?.['write'] ?? false}
                              // disabled={item.identifier !== selectedItemId}
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) => {
                                e.stopPropagation()
                                if (selectedItemId !== item.identifier) {
                                  handleItemClick(item.identifier)
                                }
                                handleCheckboxChange(e.target.checked, 'write', item.identifier)
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </>
          )
        })}
      </div>
    </>
  )
}

export default AssigmentListGroup
